import Vue from 'vue'
import appHeader from './simple/appHeader'
// import common from './global/common/'
import appSelectBar from './simple/appSelectBar'
import appButton from './simple/appButton'
import appButtonCircle from './simple/appButtonCircle'
import appDate from './simple/appDate'
import appConfirmDialog from './simple/appConfirmDialog'
import appSortList from './simple/appSortList'
import appEmpty from './simple/empty'
import appWrong from './simple/appWrong'
import appTipsDialog from './simple/appTipsDialog'

Vue.use(appSortList)
Vue.use(appConfirmDialog)
Vue.use(appDate)
Vue.use(appButtonCircle)
Vue.use(appButton)
Vue.use(appHeader)
Vue.use(appSelectBar)
Vue.use(appEmpty)
Vue.use(appWrong)
Vue.use(appTipsDialog)
// Vue.use(common)



// WEBPACK FOOTER //
// ./src/components/index.js